
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 12.015C1 5.932 5.858 1 11.85 1 17.843 1 22.7 5.932 22.7 12.015c0 6.084-4.857 11.015-10.85 11.015C5.858 23.03 1 18.1 1 12.015zm16.498-2.217s-.114-.827-.46-1.192c-.44-.478-.932-.48-1.158-.508-1.617-.122-4.043-.122-4.043-.122h-.005s-2.426 0-4.043.122c-.226.028-.718.03-1.158.508-.347.365-.46 1.192-.46 1.192s-.115.972-.115 1.943v.911c0 .972.116 1.943.116 1.943s.112.828.459 1.192c.44.479 1.017.464 1.274.513.925.093 3.93.121 3.93.121s2.428-.003 4.045-.125c.226-.028.719-.03 1.158-.509.346-.364.46-1.192.46-1.192s.115-.971.115-1.943v-.91c0-.972-.115-1.944-.115-1.944zm-6.857 3.958v-3.373l3.123 1.692-3.123 1.681z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    